import { Action } from '@ngrx/store';
import { CashTransaction } from '../../model/CashTransaction';

export enum CashTransactionActionTypes {
  InitCashTransactions = 'InitCashTransactions',
  AddCashTransaction = 'AddCashTransaction',
  RemoveCashTransaction = 'RemoveCashTransaction',
  UpdateCashTransaction = 'UpdateCashTransaction',
}

export class InitCashTransactions implements Action {
  readonly type = CashTransactionActionTypes.InitCashTransactions;

  constructor(public payload: any) {
  }
}

export class AddCashTransaction implements Action {
  readonly type = CashTransactionActionTypes.AddCashTransaction;

  constructor(public payload: CashTransaction) {
  }
}

export class RemoveCashTransaction implements Action {
  readonly type = CashTransactionActionTypes.RemoveCashTransaction;

  constructor(public payload: string) {
  }
}

export class UpdateCashTransaction implements Action {
  readonly type = CashTransactionActionTypes.UpdateCashTransaction;

  constructor(public payload: CashTransaction) {
  }
}

export type CashTransactionActions =
  InitCashTransactions |
  AddCashTransaction |
  RemoveCashTransaction |
  UpdateCashTransaction;
